import React from "react";
import { Route } from "react-router-dom";
import { Switch } from "react-router";
import { LoginV2 } from "./login";
import { RegisterV2 } from "./register";

export const AuthV2 = () => {
  return <div>
    <Switch>
      <Route path="/auth/login" component={LoginV2} />
      <Route path="/auth/register" component={RegisterV2} />
    </Switch>
  </div>;
};
